/* RavenTorch - purchase panel.
 *
 * One product, one decision: the button puts exactly the quantity on screen into
 * the cart and goes to checkout.
 *
 * WHY THERE IS NO AJAX HERE ANY MORE
 *
 * The first version did this:
 *
 *   post('/cart/clear.js')            <- request 1, answers with Clear-Site-Data
 *     .then(post('/cart/add.js'))     <- request 2
 *     .then(r => r.json())            <- a 429 body is HTML, so this throws
 *     .catch(() => form.submit())     <- native POST to /cart/add
 *
 * Two rapid writes to the cart are enough for Shopify's edge to answer 429 and
 * open a bot challenge. json() then threw on the HTML body, the catch posted the
 * form, and the customer was stranded on "Your connection needs to be verified"
 * with no way forward. Reproduced on an iPhone.
 *
 * The second attempt replaced both calls with one /cart/update.js. That returns
 * 422: update.js changes the quantity of a line already in the cart, it does not
 * create one.
 *
 * So the cart API is out of the path entirely. A cart permalink -
 * /cart/<variant>:<qty> - builds a cart containing exactly those items and
 * nothing else, which is the behaviour this shop wanted from clear-then-add in
 * the first place. With ?return_to=/checkout it is a single GET from tapping the
 * button to the payment page: no fetch, no JSON parsing, no second write, and
 * no failure mode that ends on an error page. If the edge ever does challenge
 * it, the customer answers the challenge and continues to checkout, because a
 * navigation is resumable and a POST from a dead script is not.
 */
(function () {
  'use strict';

  /* Shopify encodes the separator convention in the token name: {{amount}} is
     1,234.56 while {{amount_with_comma_separator}} is 1.234,56. A one-line
     replace ignores that and prints 149.70 on a shop formatted for 149,70 -
     visible on every keystroke once the total is live. */
  function money(cents, format) {
    var fmt = format || '{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = m ? m[1] : 'amount';

    function build(thousands, decimal, places) {
      var parts = (Math.round(cents) / 100).toFixed(places).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places > 0 ? whole + decimal + parts[1] : whole;
    }

    var v;
    switch (token) {
      case 'amount_no_decimals': v = build(',', '.', 0); break;
      case 'amount_with_comma_separator': v = build('.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': v = build('.', ',', 0); break;
      case 'amount_with_apostrophe_separator': v = build("'", '.', 2); break;
      case 'amount_with_space_separator': v = build(' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': v = build(' ', ',', 0); break;
      default: v = build(',', '.', 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  window.rtInitBuy = function () {
    document.querySelectorAll('[data-rt-buy]').forEach(function (root) {
      if (root._rtBound) return;
      root._rtBound = true;

      var dataEl = root.querySelector('[data-rt-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var fmt = root.getAttribute('data-money-format') || '{{amount}}';
      var idInput = root.querySelector('[data-rt-variant-id]');
      var priceEl = root.querySelector('[data-rt-price]');
      var compareEl = root.querySelector('[data-rt-compare]');
      var qtyField = root.querySelector('[data-rt-qty]');
      var totalEl = root.querySelector('[data-rt-total]');
      var noteEl = root.querySelector('[data-rt-total-note]');
      var submit = root.querySelector('[data-rt-submit]');
      var stickTotal = document.querySelector('[data-rt-stick-total]');

      var current = variants.filter(function (v) {
        return idInput && String(v.id) === String(idInput.value);
      })[0] || variants[0];

      function qty() {
        var n = parseInt(qtyField ? qtyField.value : '1', 10);
        return (isFinite(n) && n > 0) ? n : 1;
      }

      function render() {
        if (!current) return;
        var q = qty();
        var total = current.price * q;
        if (totalEl) totalEl.textContent = money(total, fmt);
        if (stickTotal) stickTotal.textContent = money(total, fmt);
        if (noteEl) {
          noteEl.textContent = q > 1 ? ' · ' + q + ' × ' + money(current.price, fmt) : '';
        }
      }

      function select(v) {
        if (!v) return;
        current = v;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        if (compareEl) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          if (has) compareEl.textContent = money(v.compare_at_price, fmt);
          compareEl.hidden = !has;
        }
        if (submit) {
          submit.disabled = !v.available;
          var label = submit.querySelector('[data-rt-submit-label]');
          if (label) label.textContent = v.available ? submit.getAttribute('data-label') : 'Sold out';
        }
        render();
      }

      root.querySelectorAll('[data-rt-option]').forEach(function (input) {
        input.addEventListener('change', function () {
          select(variants.filter(function (v) { return String(v.id) === String(input.value); })[0]);
        });
      });

      root.querySelectorAll('[data-rt-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyField) return;
          qtyField.value = Math.max(1, qty() + parseInt(btn.getAttribute('data-rt-qty-step'), 10));
          render();
        });
      });

      if (qtyField) {
        qtyField.addEventListener('input', render);
        qtyField.addEventListener('change', function () { qtyField.value = qty(); render(); });
        qtyField.addEventListener('blur', function () { qtyField.value = qty(); render(); });
      }

      render();

      var form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submit) submit.classList.add('is-loading');

        /* A cart permalink replaces the cart with exactly this line, so the
           quantity is always the one on screen no matter what a previous visit
           left behind. One navigation, straight through to payment. */
        window.location.href =
          '/cart/' + Number(idInput.value) + ':' + qty() + '?return_to=/checkout';
      });
    });
  };

  if (window.__rtReady) window.rtInitBuy();
})();
